import React, { useEffect, useState } from 'react';

const SamlSignIn = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {

        const processSAMLAssertion = async () => {
            try {
                // Get the SAML assertion from the URL
                const assertion = new URLSearchParams(window.location.search).get('SAMLResponse');
                if (!assertion) {
                    throw new Error('SAML assertion not found in URL');
                }

                // Send the SAML assertion to your backend for validation
                const response = await fetch('/login/saml2/sso/nia', {
                    method: 'POST',
                    body: JSON.stringify({ assertion }),
                    headers: { 'Content-Type': 'application/json' },
                });
                if (!response.ok) {
                    throw new Error('Error validating SAML assertion');
                }

                // Parse the response from the backend
                const data = await response.json();
                if (!data.authenticated) {
                    throw new Error('SAML assertion not authenticated');
                }

                // Set the authenticated state and token
                setIsAuthenticated(true);
                localStorage.setItem('token', data.token);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        processSAMLAssertion();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (isAuthenticated) {
        return <div>You are authenticated!</div>;
    }

    return <div>Something went wrong</div>;
};

export default SamlSignIn;